import { Pagination } from "antd";
import React, { FC, JSX, useEffect } from "react";
import { PageParams } from "../../entities/interfaces/misc";
import { useSearchParams, useNavigate } from "react-router-dom";
import { usePage } from "../../hooks/usePage";

type Props = {
  children: JSX.Element;
  fetcher: (pageParams: PageParams) => void;
  totalPage?: number;
};

const PaginationWrapper: FC<Props> = ({ children, fetcher, totalPage }) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  // Read page and pageSize from URL or set defaults
  const currentPage = parseInt(searchParams.get("page") || "1", 10);
  const pageSize = parseInt(searchParams.get("pageSize") || "10", 10);

  const { page, perPage, setPage } = usePage(currentPage, pageSize);

  useEffect(() => {
    fetcher({ page, perPage });
  }, []);

  const onChange = (page: number, perPage: number) => {
    const newParams = { page, perPage };
    setPage(newParams);
    fetcher(newParams);
    const params = new URLSearchParams(searchParams.toString());
    params.set("page", page.toString());
    params.set("pageSize", perPage.toString());
    navigate({ search: params.toString() }, { replace: true });
  };
  return (
    <>
      {children}
      {totalPage ? (
        <Pagination
          className="mt-3"
          align="end"
          showSizeChanger
          current={page}
          pageSize={perPage}
          total={totalPage}
          onChange={onChange}
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default PaginationWrapper;
